import { jsml } from "./jsml.js";
import { methodDisplaySpecialOffers } from "./renderFilter/methodDisplaySpecialOffers.js";
import { methodDisplayNull } from "./renderFilter/methodDisplayNull.js";
import { methodDisplayRooms } from "./renderFilter/methodDisplayRooms.js";
import { methodDisplayMeetingsEvents } from "./renderFilter/methodDisplayMeetingsEvents.js";
import { methodDisplayTheDesign } from "./renderFilter/methodDisplayTheDesign.js";
import { retrieveComparisonIds } from "./integrateFilterCompare.js";


// Get current language
const getCurrentLanguage = () => {
    return document.getElementById('current_language').dataset.language;
}
  
// Search query string based on the URL, and then the parameter you wish to find
const getQueryString = (url, param) => {
    url = new URL(url);
    return url.searchParams.get(param);
}

// The method for displaying rooms to the page

// The method for handling a data request
const genericDataRequest = ($url, $method) => {

    /* Filter Scripts */
    var oReq = new XMLHttpRequest();
    oReq.addEventListener("progress", updateProgress);
    oReq.addEventListener("load", transferComplete);
    oReq.addEventListener("error", transferFailed);
    oReq.addEventListener("abort", transferCanceled);

    // Multi language URL structure
    // http://thereverie-2021_staging.local/wp-json/wp/v2/rooms?per_page=100&status=publish&lang=en&roomtypes=25

    oReq.open("GET", $url);
    oReq.send();

    // progress on transfers from the server to the client (downloads)
    function updateProgress (oEvent) {
        if (oEvent.lengthComputable) {
            var percentComplete = oEvent.loaded / oEvent.total * 100;
        // ...
        } else {
         
           // Unable to compute progress information since the total size is unknown
        }
    }

    //   methodDisplayNull(completedRequest, $url);

    function transferComplete(evt) {
        let completedRequest = JSON.parse(evt.currentTarget.response);

        if(completedRequest.length === 0) {
            methodDisplayNull(completedRequest, $url);
            return;
        }


        // Run method on completion
        if($method == 'rooms') {
            methodDisplayRooms(completedRequest, $url);
        }

        if($method == 'special-offers') {
            methodDisplaySpecialOffers(completedRequest, $url);
        }

        if($method == 'meetings') {
            methodDisplayMeetingsEvents(completedRequest, $url);
        }

        if($method == 'the-design') {
            methodDisplayTheDesign(completedRequest, $url);
        }
    }

    function transferFailed(evt) {
        console.log("An error occurred while transferring the data.");
    }

    function transferCanceled(evt) {
        console.log("The transfer has been canceled by the user.");
    }

}

const $restAPI = window.location.protocol + '//' + window.location.hostname + '/wp-json/wp/v2/';

// Build a URL contrust request
const buildGenericDataRequest = ($method = 'rooms', $roomtype = null, $count = 100) => {
  
    const $lang = '&lang=' + getCurrentLanguage();

    if($method == 'rooms') {
        if ($roomtype == 'initial') {
            $roomtype = '';
        } else if($roomtype == 'all') {
            $roomtype = '';
        } else {
            $roomtype = $roomtype ? '&roomtypes=' + $roomtype : '';
        }
    }

    if($method == 'special-offers') {
        if ($roomtype == 'initial') {
            $roomtype = '';
        } else if($roomtype == 'all') {
            $roomtype = '';
        } else {
            $roomtype = $roomtype ? '&offertypes=' + $roomtype : '';
        }
    }


    if($method == 'meetings') {
        if ($roomtype == 'initial') {
            $roomtype = '';
        } else if($roomtype == 'all') {
            $roomtype = '';
        } else {
            $roomtype = $roomtype ? '&meetings=' + $roomtype : '';
        }
    }

    //console.log(`http://thereverie-2021_staging.local/wp-json/wp/v2/${$method}?_embed&per_page=${$count}&status=publish${$lang}${$roomtype}`);
    genericDataRequest(`${$restAPI}${$method}?per_page=${$count}&status=publish${$lang}${$roomtype}`, $method);
}



// Initialise merge with Compare.js
retrieveComparisonIds();


// ------------------------------------------------------------------------------------------- //
// --------------------------------- Script Initialisation -----------------------------------
// ------------------------------------------------------------------------------------------- //

// Get Data Attributes
const dataParamName = new URL(window.location.href).searchParams.get("target"); // get the data-name from the URL
const dataParamShowAll = document.querySelectorAll('[data-attr="show-all-on-load"]');
const allDataFilters = document.querySelectorAll('[data-filter]'); // Select all data-filters on page
const filterDataSet = (document.querySelector('[data-filter-default]')) ? document.querySelector('[data-filter-default]').dataset.filterDefault : null; // Get the default data attribute
const getFilterBlock = document.getElementById('filter-and-comparison-block'); 



// Create initial event for rooms
if(dataParamName) {
    dataParamName.toLowerCase();
    let getParam = document.querySelector('[data-filter-name="' + dataParamName + '"]');

    // Remove actve state from data-filters
    allDataFilters.forEach((df) => {
        df.classList.remove('data-filter-active');
    });

    // Add active state to data-filter
    getParam.classList.add('data-filter-active');

    setTimeout(() => {
        //getFilterBlock.scrollIntoView();
       
        window.scrollTo(getFilterBlock.offsetLeft, getFilterBlock.offsetTop - 150);
    }, 20);

    buildGenericDataRequest(getParam.dataset.filterMethod,  getParam.dataset.filterRoomtype, 100);
} else {

if(dataParamShowAll) {
    if(filterDataSet) {
        buildGenericDataRequest(filterDataSet,  'initial', 100);
    }
}

}
// If no data-name is set, use the default
if(!dataParamName) {
    if(!dataParamShowAll) {

        if(filterDataSet) {
            buildGenericDataRequest(filterDataSet, 'initial', 3);
        }
    }
}


allDataFilters.forEach((dataFilter) => {
    dataFilter.addEventListener('click', () => {

        // Remove the 'View More' Button
        let viewMoreBtn = document.getElementById('filter-more');

        if(viewMoreBtn) {
            viewMoreBtn.remove();
        }

        // Remove the loaded event
        document.getElementById('filter-results').classList.remove('filter-results-loaded');

        // Scroll to the correct place in the window
        window.scrollTo({top: document.getElementById('filter-results').getBoundingClientRect().top + window.pageYOffset + -200, behavior: 'smooth'});


        // Manage staete of individual data-filders
        allDataFilters.forEach((df) => {
            df.classList.remove('data-filter-active');
        });
        dataFilter.classList.add('data-filter-active');

        // Build the generic data-request
        buildGenericDataRequest(dataFilter.dataset.filterMethod, dataFilter.dataset.filterRoomtype);
    });
});


// Build filter More Eventlistener
const filterMoreBtn = document.getElementById('filter-more');
if(filterMoreBtn) {
    filterMoreBtn.addEventListener('click', (e) => {

        let viewMoreBtn = document.getElementById('filter-more');
        
        if(viewMoreBtn) {
            viewMoreBtn.remove();
        }

        // Remove the loaded event
        document.getElementById('filter-results').classList.remove('filter-results-loaded');

        e.preventDefault();
        if(filterDataSet) {
            buildGenericDataRequest(filterDataSet, 'initial', 100);
        }
    });
}